module.exports = __webpack_public_path__ + "static/media/vip-ranking.49ae4d95.png";